import { __assign } from "tslib";
import React, { useMemo } from "react";
import { TextField, MenuItem, makeStyles } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useConfigs } from "../config-provider";
var useStyles = makeStyles(function () {
  return {
    select: {
      background: "white !important"
    },
    textField: {
      cursor: "pointer",
      "&::before": {
        border: "0 !important",
        content: ""
      },
      "&::after": {
        border: "0 !important",
        content: ""
      },
      "& fieldset": {
        visibility: "hidden !important"
      }
    }
  };
});

var Select = function Select(props) {
  var _a = props.options,
      options = _a === void 0 ? [] : _a,
      inputValue = props.value,
      _b = props.size,
      size = _b === void 0 ? "medium" : _b,
      _c = props.placeholder,
      placeholder = _c === void 0 ? "" : _c,
      _d = props.label,
      label = _d === void 0 ? "" : _d,
      _e = props.fullWidth,
      fullWidth = _e === void 0 ? true : _e,
      _f = props.freeSolo,
      freeSolo = _f === void 0 ? false : _f,
      _g = props.hideAllOption,
      hideAllOption = _g === void 0 ? false : _g,
      _h = props.filter,
      filter = _h === void 0 ? true : _h,
      _j = props.noBorder,
      noBorder = _j === void 0 ? false : _j,
      startAdornment = props.startAdornment,
      _k = props.disabled,
      disabled = _k === void 0 ? false : _k,
      disableClearable = props.disableClearable,
      browserAutoComplete = props.browserAutoComplete,
      classes = props.classes,
      _l = props.variant,
      variant = _l === void 0 ? "outlined" : _l,
      className = props.className,
      style = props.style,
      renderOption = props.renderOption,
      _onChange = props.onChange;
  var locale = useConfigs().locale;
  var styles = useStyles();
  var memoOptions = useMemo(function () {
    return hideAllOption ? options : [{
      value: "all",
      label: locale.common.all
    }].concat(options);
  }, [options, hideAllOption, locale]);

  function handleChange(event, option) {
    _onChange && _onChange(typeof option === "object" && option !== null ? option.value : option);
  }

  var memoValue = useMemo(function () {
    if (filter && inputValue !== undefined && inputValue !== null) {
      return memoOptions.find(function (item) {
        return item.value === inputValue;
      }) || null;
    }

    return inputValue;
  }, [inputValue, memoOptions, filter]);
  return filter ? React.createElement(Autocomplete, {
    fullWidth: fullWidth,
    size: size,
    clearOnBlur: true,
    disableClearable: disableClearable,
    freeSolo: freeSolo,
    options: options,
    style: style,
    classes: classes,
    className: className,
    disabled: disabled,
    value: memoValue,
    onChange: handleChange,
    renderOption: renderOption,
    getOptionLabel: function getOptionLabel(option) {
      return option.label || option;
    },
    renderInput: function renderInput(params) {
      return React.createElement(TextField, __assign({}, params, {
        label: label,
        style: {
          background: "white"
        },
        className: noBorder ? styles.textField : "",
        placeholder: placeholder,
        disabled: disabled,
        autoComplete: browserAutoComplete,
        InputProps: __assign(__assign({}, params.InputProps), {
          startAdornment: startAdornment
        }),
        variant: variant
      }));
    }
  }) : React.createElement(TextField, {
    fullWidth: fullWidth,
    size: size,
    select: true,
    style: style,
    classes: classes,
    className: "".concat(className, " ").concat(noBorder ? styles.textField : ""),
    value: memoValue,
    label: label,
    disabled: disabled,
    autoComplete: browserAutoComplete,
    InputProps: {
      startAdornment: startAdornment ? React.createElement("div", {
        style: {
          display: "flex",
          marginLeft: -4,
          marginRight: 4
        }
      }, startAdornment) : undefined
    },
    SelectProps: {
      classes: {
        select: styles.select
      },
      MenuProps: {
        style: {
          marginTop: size === "medium" ? 56 : 40,
          marginLeft: startAdornment === undefined ? 0 : -40
        },
        anchorOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        getContentAnchorEl: null
      }
    },
    variant: variant,
    onChange: function onChange(e) {
      _onChange && _onChange(e.target.value);
    }
  }, memoOptions.map(function (option) {
    return React.createElement(MenuItem, {
      key: option.value,
      value: option.value
    }, option.label);
  }));
};

export default Select;